// The UI's API base paths are relative, so the same built bundle works
// both behind production Caddy (deploy/Caddyfile: `/api/*` -> Core with
// the prefix stripped, `/store/*` -> Store likewise) and behind the Vite
// dev server (vite.config.ts's own /api and /store proxies, same
// stripping). Nothing in application code needs to know which.
//
// Both are still overridable at build time (VITE_API_BASE / VITE_STORE_BASE)
// for a non-default deployment layout, per docs/plan/phase-10-ui.md's
// "Make the UI's API base path configurable".
export const API_BASE: string = import.meta.env.VITE_API_BASE ?? "/api";
export const STORE_BASE: string = import.meta.env.VITE_STORE_BASE ?? "/store";
